import { call, put, takeLatest } from "redux-saga/effects";
import {
  SG_GET_MY_SLACK_WORKSPACES,
  GET_MY_SLACK_WORKSPACES,
  SG_GET_SLACK_WORKSPACE_USERS,
  GET_SLACK_WORKSPACE_USERS,
  SG_CREATE_SLACK_TASK,
  CREATE_SLACK_TASK,
  SG_GET_SLACK_TASK_HISTORY,
  GET_SLACK_TASK_HISTORY,
  SG_GET_SLACK_MY_TASK_HISTORY,
  GET_SLACK_MY_TASK_HISTORY,
  SG_GET_SLACK_DAILY_DIGEST,
  GET_SLACK_DAILY_DIGEST,
  SG_GET_SLACK_MY_DAILY_DIGEST,
  GET_SLACK_MY_DAILY_DIGEST,
  SG_GET_SLACK_WORKSPACE_TASKS,
  GET_SLACK_WORKSPACE_TASKS,
  SG_GET_SLACK_TASK_METRICS,
  GET_SLACK_TASK_METRICS,
  SG_GET_SLACK_MEETINGS,
  GET_SLACK_MEETINGS,
  SG_GET_SLACK_MEETING_TASKS,
  GET_SLACK_MEETING_TASKS,
  GET_ERRORS,
} from "constants/actions";

import * as API from "constants/slack_task_api";

// ==================== MY WORKSPACES ====================
function* getMySlackWorkspaces() {
  try {
    const response = yield call(API.GET_MY_SLACK_WORKSPACES);
    yield put({ type: GET_MY_SLACK_WORKSPACES, payload: response.data.data });
  } catch (error) {
    console.error("getMySlackWorkspaces error:", error);
    yield put({
      type: GET_ERRORS,
      payload: { error: error.response?.data || "Failed to fetch workspaces" },
    });
  }
}

// ==================== WORKSPACE USERS ====================
function* getSlackWorkspaceUsers(action) {
  try {
    const { workspaceId, queryParams } = action.payload;
    const response = yield call(API.GET_SLACK_WORKSPACE_USERS, workspaceId, queryParams);
    yield put({ type: GET_SLACK_WORKSPACE_USERS, payload: response.data.data });
  } catch (error) {
    console.error("getSlackWorkspaceUsers error:", error);
    yield put({
      type: GET_ERRORS,
      payload: { error: error.response?.data || "Failed to fetch workspace users" },
    });
  }
}

// ==================== CREATE TASK ====================
function* createSlackTask(action) {
  try {
    const { workspaceId, taskData } = action.payload;
    const response = yield call(API.CREATE_SLACK_TASK, workspaceId, taskData);
    yield put({ type: CREATE_SLACK_TASK, payload: response.data.data });
  } catch (error) {
    console.error("createSlackTask error:", error);
    yield put({
      type: GET_ERRORS,
      payload: { error: error.response?.data || "Failed to create task" },
    });
  }
}

// ==================== TASK HISTORY ====================
function* getSlackTaskHistory(action) {
  try {
    const { workspaceId, userId, queryParams } = action.payload;
    const response = yield call(API.GET_SLACK_TASK_HISTORY, workspaceId, userId, queryParams);
    yield put({ type: GET_SLACK_TASK_HISTORY, payload: response.data.data });
  } catch (error) {
    console.error("getSlackTaskHistory error:", error);
    yield put({
      type: GET_ERRORS,
      payload: { error: error.response?.data || "Failed to fetch task history" },
    });
  }
}

function* getSlackMyTaskHistory(action) {
  try {
    const { workspaceId, queryParams } = action.payload;
    const response = yield call(API.GET_SLACK_MY_TASK_HISTORY, workspaceId, queryParams);
    yield put({ type: GET_SLACK_MY_TASK_HISTORY, payload: response.data.data });
  } catch (error) {
    console.error("getSlackMyTaskHistory error:", error);
    yield put({
      type: GET_ERRORS,
      payload: { error: error.response?.data || "Failed to fetch my task history" },
    });
  }
}

// ==================== DAILY DIGEST ====================
function* getSlackDailyDigest(action) {
  try {
    const { workspaceId, userId, queryParams } = action.payload;
    const response = yield call(API.GET_SLACK_DAILY_DIGEST, workspaceId, userId, queryParams);
    yield put({ type: GET_SLACK_DAILY_DIGEST, payload: response.data.data });
  } catch (error) {
    console.error("getSlackDailyDigest error:", error);
    yield put({
      type: GET_ERRORS,
      payload: { error: error.response?.data || "Failed to fetch daily digest" },
    });
  }
}

function* getSlackMyDailyDigest(action) {
  try {
    const { workspaceId, queryParams } = action.payload;
    const response = yield call(API.GET_SLACK_MY_DAILY_DIGEST, workspaceId, queryParams);
    yield put({ type: GET_SLACK_MY_DAILY_DIGEST, payload: response.data.data });
  } catch (error) {
    console.error("getSlackMyDailyDigest error:", error);
    yield put({
      type: GET_ERRORS,
      payload: { error: error.response?.data || "Failed to fetch my daily digest" },
    });
  }
}

// ==================== WORKSPACE TASKS ====================
function* getSlackWorkspaceTasks(action) {
  try {
    const { workspaceId, queryParams } = action.payload;
    const response = yield call(API.GET_SLACK_WORKSPACE_TASKS, workspaceId, queryParams);
    yield put({ type: GET_SLACK_WORKSPACE_TASKS, payload: response.data.data });
  } catch (error) {
    console.error("getSlackWorkspaceTasks error:", error);
    yield put({
      type: GET_ERRORS,
      payload: { error: error.response?.data || "Failed to fetch workspace tasks" },
    });
  }
}

// ==================== TASK METRICS ====================
function* getSlackTaskMetrics(action) {
  try {
    const { workspaceId, queryParams } = action.payload;
    const response = yield call(API.GET_SLACK_TASK_METRICS, workspaceId, queryParams);
    yield put({ type: GET_SLACK_TASK_METRICS, payload: response.data.data });
  } catch (error) {
    console.error("getSlackTaskMetrics error:", error);
    yield put({
      type: GET_ERRORS,
      payload: { error: error.response?.data || "Failed to fetch task metrics" },
    });
  }
}

// ==================== MEETINGS ====================
function* getSlackMeetings(action) {
  try {
    const { workspaceId, queryParams } = action.payload;
    const response = yield call(API.GET_SLACK_MEETINGS, workspaceId, queryParams);
    yield put({ type: GET_SLACK_MEETINGS, payload: response.data.data });
  } catch (error) {
    console.error("getSlackMeetings error:", error);
    yield put({
      type: GET_ERRORS,
      payload: { error: error.response?.data || "Failed to fetch meetings" },
    });
  }
}

// ==================== MEETING TASKS ====================
function* getSlackMeetingTasks(action) {
  try {
    const { workspaceId, meetingId } = action.payload;
    const response = yield call(API.GET_SLACK_MEETING_TASKS, workspaceId, meetingId);
    yield put({ type: GET_SLACK_MEETING_TASKS, payload: response.data.data });
  } catch (error) {
    console.error("getSlackMeetingTasks error:", error);
    yield put({
      type: GET_ERRORS,
      payload: { error: error.response?.data || "Failed to fetch meeting tasks" },
    });
  }
}

// ==================== WATCHERS ====================
export default function* slackTasksSaga() {
  yield takeLatest(SG_GET_MY_SLACK_WORKSPACES, getMySlackWorkspaces);
  yield takeLatest(SG_GET_SLACK_WORKSPACE_USERS, getSlackWorkspaceUsers);
  yield takeLatest(SG_CREATE_SLACK_TASK, createSlackTask);
  yield takeLatest(SG_GET_SLACK_TASK_HISTORY, getSlackTaskHistory);
  yield takeLatest(SG_GET_SLACK_MY_TASK_HISTORY, getSlackMyTaskHistory);
  yield takeLatest(SG_GET_SLACK_DAILY_DIGEST, getSlackDailyDigest);
  yield takeLatest(SG_GET_SLACK_MY_DAILY_DIGEST, getSlackMyDailyDigest);
  yield takeLatest(SG_GET_SLACK_WORKSPACE_TASKS, getSlackWorkspaceTasks);
  yield takeLatest(SG_GET_SLACK_TASK_METRICS, getSlackTaskMetrics);
  yield takeLatest(SG_GET_SLACK_MEETINGS, getSlackMeetings);
  yield takeLatest(SG_GET_SLACK_MEETING_TASKS, getSlackMeetingTasks);
}